import CT from '@marketplace-ai/tags';
import { ColDef } from 'ag-grid-community';
import { createValidCol } from '~/components/agGrid/columns/sharedColumns';
import { ACTIONS_COLUMN_BASE, ActionsRenderer, type ActionDef } from '~/components/Table/gridUtil';
import { CMETrainingFormValues } from './types';

export const createCMETrainingCols = ({
  handleEdit,
  handleDelete,
}: {
  handleEdit: (id: number) => void;

  handleDelete: (id: number) => void;
}): ColDef[] => [
  { field: 'id', hide: true },
  createValidCol(),
  { field: 'activityDate', headerName: 'Activity Date' },
  { field: 'courseTitle', headerName: 'Course Title' },
  { field: 'creditType.label', headerName: 'Credit Type' },
  { field: 'creditsEarned', headerName: 'Credits Earned' },
  {
    ...ACTIONS_COLUMN_BASE,
    width: 80,
    cellRenderer: ActionsRenderer,
    cellRendererParams: {
      actions: [
        { type: 'edit', handler: handleEdit, cyTag: CT.boardCerts.table.editBtn },
        { type: 'delete', handler: handleDelete, cyTag: CT.privileges.table.deleteBtn },
      ] satisfies ActionDef[],
    },
  },
];

export const CREDIT_TYPES = [
  'AAFP Elective Credit',
  'AAFP Prescribed Credit',
  'AMA PRA Category 1',
  'AMA PRA Category 2',
  'AOA Category 1-A',
  'AOA Category 1-B',
  'AOA Category 2-A',
  'AOA Category 2-B',
];

export const CREDIT_TYPE_OPTIONS = CREDIT_TYPES.map((type) => ({ label: type, value: type }));

export const emptyForm: CMETrainingFormValues = {
  activityDate: '',
  certReceived: '',
  cost: 0.0,
  costFormatted: '',
  courseTitle: '',
  creditsEarned: 0.0,
  creditType: CREDIT_TYPE_OPTIONS[0],
  details: '',
  eduProviderName: '',
  location: '',
};
